import { createAction, props } from '@ngrx/store';

export const setEntidadesSinCredenciales = createAction(
  '[Entidades Sin Credenciales] Set',
  props<{ item: string }>()
);
